import type { ReactNode } from 'react';

interface EmptyStateProps {
  readonly title: string;
  readonly description?: string;
  readonly action?: ReactNode;
  readonly glyph?: ReactNode;
}

/**
 * Empty state matching the shell.css `.state-empty` pattern. Used when an
 * authenticated read returns successfully with zero rows.
 */
export function EmptyState({ title, description, action, glyph }: EmptyStateProps) {
  return (
    <div className="state state-empty">
      <div className="glyph">
        {glyph ?? (
          <svg viewBox="0 0 24 24">
            <path d="M3 7h18M3 12h18M3 17h12" />
          </svg>
        )}
      </div>
      <h3>{title}</h3>
      {description ? <p>{description}</p> : null}
      {action}
    </div>
  );
}
